import React, { useState } from "react";
import { useMutation } from '@apollo/client';
import { Container, Button, Typography, TextField, Paper, makeStyles, Snackbar, CircularProgress } from "@material-ui/core";
import gql from 'graphql-tag';
import MuiAlert from '@material-ui/lab/Alert';

export const AddCompany = () => {
  const ADD_New_COMPANY_Request = gql`
    mutation AddNewCompanyRequest($companyName: String!,$reason: String!) {
        addNewCompanyRequest(requestedCompany: $companyName,reason:$reason) {
            id
        }
    }
`;
    const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  fieldSpacing: {
    marginBottom: theme.spacing(2),
  },
}));


    const classes = useStyles();
  const [addReasonError, setAddReasonError] = useState("");
  const [reason, setReason] = useState("");
  const [addCompanyError, setAddCompanyError] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [addCompanyMutation, { error: addCompanyErrors }] = useMutation(ADD_New_COMPANY_Request);
  const [RequestedNewCompanies, setRequestedNewCompanies] = useState([]);
  const [addCompanyOpen, setAddCompanyOpen] = useState(true);
  const [loading, setLoading] = useState(false);
      const [companies, setCompanies] = useState([]);
 const onAddCompany = () => {
        if (companyName !== "" && reason !== "") {
            if (companies.some(e => e.name.toLowerCase() === companyName.toLowerCase()) || RequestedNewCompanies.some(e => e.requestedCompany.toLowerCase() === companyName.toLowerCase())) {
                setAddCompanyError("Company Already Exists")
            }
            else {
                addCompanyMutation({ variables: { companyName: companyName, reason: reason } })
                    .then(r => {
                        setAddCompanyOpen(false);
                        setSnackBarOpen(true);
                    })
                    .catch(e => {
                        setAddCompanyError("An error occured")
                    })
            }
        }
        else if (companyName === "")
            setAddCompanyError("Company Name is mandatory")
        else if (reason === "")
            setAddReasonError("Reason is mandatory")

    }
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [errorSnackBarOpen, setErrorSnackBarOpen] = useState(false);
    const [errorSnackBarText, setErrorSnackBarText] = useState("");

    const handleErrorSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorSnackBarOpen(false);
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarOpen(false);
    }

    const Alert = (props) => {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    return (
        <Container maxWidth={'xl'} disableGutters={true}>
            <Typography variant="h4">Add Company</Typography>

            <Paper className={classes.root} >
                <React.Fragment>
                    <TextField className={classes.fieldSpacing}
                        color="primary"
                        variant="outlined"
                        label="Company Name"
                        fullWidth
                        onChange={(e) => { setCompanyName(e.target.value); setAddCompanyError("") }}
                        error={addCompanyError.length > 0}
                        helperText={addCompanyError}
                    />
                    <TextField className={classes.fieldSpacing}
                        color="primary"
                        variant="outlined"
                        label="Reason"
                        fullWidth
                        onChange={(e) => { setReason(e.target.value); setAddReasonError("") }}
                        error={addReasonError.length > 0}
                        helperText={addReasonError}
                    />
                    {loading ?
                        <CircularProgress />
                        :
                        <Button className={classes.fieldSpacing}
                        label="Submit Request"
                color="primary"
                variant="contained"
                        onClick={onAddCompany}
                    >Submit Request</Button>
                    }


                    <Snackbar
                        open={snackBarOpen}
                        autoHideDuration={5000}
                        onClose={handleSnackbarClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    >
                        <Alert onClose={handleSnackbarClose} severity="success">
                            Request has been submitted
                        </Alert>
                    </Snackbar>
                    <Snackbar
                        open={errorSnackBarOpen}
                        autoHideDuration={5000}
                        onClose={handleErrorSnackbarClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    >
                        <Alert onClose={handleErrorSnackbarClose} severity="error">
                            {errorSnackBarText}
                        </Alert>
                    </Snackbar>
                </React.Fragment>
            </Paper>
        </Container>
    )
}